import { DialogContentText, DialogProps, ButtonProps } from '@mui/material';

import { AppDialog } from 'components/Dialogs';
import strings from 'constants/index';

const blockquote = {
  margin: 0,
  padding: '1em',
  borderLeft: '4px solid #ccc',
};

export interface DeleteDialogProps extends DialogProps {
  entityName: string;
  onDelete: () => Promise<void>;
  buttonProps?: ButtonProps;
  additionalMessage?: string;
}

const DeleteDialog = ({
  open,
  onClose,
  entityName,
  onDelete,
  children,
  additionalMessage,
  buttonProps,
}: DeleteDialogProps) => (
  <AppDialog
    open={open}
    title={strings.warning}
    fullWidth={false}
    onClose={onClose}
    confirmButton={{
      label: strings.delete,
      props: {
        ...buttonProps,
        onClick: async () => {
          try {
            await onDelete();
            onClose({}, 'backdropClick');
          } catch (error) {
            console.error('Error during delete operation:', error);
          }
        },
      },
    }}
  >
    <DialogContentText>{strings.are_you_sure_delete.replace('{0}', entityName)}</DialogContentText>
    {!additionalMessage || <br />}
    {!additionalMessage || <div style={blockquote}>{additionalMessage}</div>}
    {children}
  </AppDialog>
);

export default DeleteDialog;
